import React from "react"
import { Image } from "@chakra-ui/image"
import { PiArrowBendDownLeftBold } from "react-icons/pi"
import { Box, Text, Center, HStack, AspectRatio } from "@chakra-ui/layout"

import Paragraph from "~components/shared/text/paragraph"
import SectionHeading from "~components/shared/text/heading"
import ZachHeadshot from "~images/zach.png"
import ResponsiveBlock from "~components/shared/layout/responsive-block"
import BookADemoButton from "~components/shared/book-a-demo-button"
import SharedStack from "~components/shared/wrappers/shared-stack"
import Pattern from "~images/pages/comparison/patterns/pattern-navy.png"
import { Icon } from "@chakra-ui/icons"

export default function BookACallWithZach() {
    return (
        <Box bg="navy.600" position="relative">
            <JoeBackground />
            <ResponsiveBlock position="relative" maxW="964px" py={16}>
                <Center
                    gap={16}
                    flexDir={{ base: "column", lg: "row" }}
                    alignItems="center"
                >
                    <AspectRatio
                        ratio={3 / 4}
                        w={{ base: "212px", lg: "312px" }}
                        rounded="xl"
                        overflow="hidden"
                    >
                        <Image src={ZachHeadshot} alt="Zach Headshot" />
                    </AspectRatio>
                    <SharedStack spacing={6}>
                        <SectionHeading
                            size="xl"
                            color="gray.50"
                            fontWeight="semibold"
                        >
                            Book a demo with Zach
                        </SectionHeading>
                        <Paragraph color="gray.50">
                            Zach will walk you through the product and show off
                            why veterinarians across the country are switching
                            to Chckvet.
                        </Paragraph>
                        <HStack spacing={2}>
                            <BookADemoButton showSubtitle />
                            <Icon
                                as={PiArrowBendDownLeftBold}
                                fontSize="2xl"
                                color="gray.200"
                                transform="translateY(8px) rotate(40deg)"
                            />
                            <Text
                                fontFamily="Handlee"
                                color="gray.50"
                                transform="rotate(-5deg)"
                            >
                                (friendly tour, not a sales call)
                            </Text>
                        </HStack>
                    </SharedStack>
                </Center>
            </ResponsiveBlock>
        </Box>
    )
}

function JoeBackground() {
    return (
        <>
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="whiteAlpha.50"
                clipPath={{
                    base: "circle(40% at 50% 0%)",
                    lg: "circle(40% at 0% -25%)",
                }}
            />
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="whiteAlpha.50"
                clipPath={{
                    base: "circle(70% at 50% 0%)",
                    lg: "circle(70% at 0% -25%)",
                }}
            />
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="whiteAlpha.50"
                clipPath={{
                    base: "circle(100% at 50% 0%)",
                    lg: "circle(100% at 0% -25%)",
                }}
            />
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgImage={Pattern}
                opacity={0.7}
            />
        </>
    )
}
